<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form" (click)="onClickForm($event)">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-group my-15">
    <label class="form-label required">User</label>
    <span class="select-user" (click)="showUsers = true;$event.stopPropagation();">
      <span *ngIf="!invoiceUser">Select user</span>
      <span *ngIf="invoiceUser">{{ invoiceUser.email }} &lt;{{ invoiceUser.fullName }}&gt;</span>
      <div *ngIf="showUsers" class="dropdown-menu show">
        <app-users-select [multiple]="false" [roles]="['mainaccount', 'deputy']" [paymentType]="'PREPAID'"
          (selectUser)="onSelectInvoiceUser($event)"></app-users-select>
      </div>
    </span>
  </div>
  <div class="form-group my-15">
    <label class="form-label required">Package</label>
    <select [(ngModel)]="model.pricingGroupId" [disabled]="!invoiceUser" formControlName="pricingGroupId" class="form-control">
      <option *ngFor="let item of pricingGroups" [value]="item.id">{{item.title}}</option>
    </select>
    <input-errors [control]="form.controls.pricingGroupId" [service]="validationService"></input-errors>
  </div>
  <div class="form-group my-15">
    <div class="input-check">
      <input id="invoice-is-payment-control" class="form-check-input" type="checkbox" [(ngModel)]="model.paid" formControlName="paid">
      <label for="invoice-is-payment-control">Paid</label>
    </div>
  </div>
  <div *ngIf="showButtons" class="hr-line-dashed"></div>
  <div *ngIf="showButtons" class="text-right buttons">
    <button id="btn-invoice-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary m-b">Apply</button>
  </div>
</form>
